import { render, staticRenderFns } from "./TarjetaProspecto.vue?vue&type=template&id=f7cbaeb8&scoped=true&"
import script from "./TarjetaProspecto.vue?vue&type=script&lang=js&"
export * from "./TarjetaProspecto.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaProspecto.vue?vue&type=style&index=0&id=f7cbaeb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cbaeb8",
  null
  
)

export default component.exports